import React from "react";
import servicesAccounts from "assets/services-image/services_account.png";

const Account = () => {
  return (<div className="services-section">
    <div className="services-section--content">
      <h2>Accounts</h2>
      <ul>
        <li>
          <p><b>Account Management:</b> Detailed profiles for each client or corporate account.</p>
        </li>
        <li>
          <p><b>Relationship Mapping:</b> Visual representation of relationship within account.</p>
        </li>
        <li>
          <p><b>Billing and Invoicing:</b> Tract billing details and generate invoices.</p>
        </li>
        <li>
          <p><b>Service Requests:</b> Manage and track service requests from accounts.</p>
        </li>
        <li>
          <p><b>Document Storage:</b> Central repository for account-related documents.</p>
        </li>
      </ul>
    </div>
    <div className="services-section--image">
      <img src={servicesAccounts} alt="Accounts"/>
    </div>
  </div>);
};

export default Account;
